import Vue from 'vue';

Vue.mixin({
  computed: {
    isLoggedIn() {
      return this.$store.getters['auth/isLoggedIn'];
    },
  },
  methods: {
    makeToast(variant, message, title = '') {
      this.$bvToast.toast(message, {
        title: title || (variant === 'success' ? 'Success' : variant === 'danger' ? 'Error' : 'Info'),
        variant,
        solid: true,
        autoHideDelay: 3000,
        toaster: 'b-toaster-top-right',
      });
    },
  },
});
